export default "__VITE_ASSET__BXAkPbUZ__"